import { render, staticRenderFns } from "./contractList.vue?vue&type=template&id=2c8d4ca2&scoped=true&"
import script from "./contractList.vue?vue&type=script&lang=js&"
export * from "./contractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d4ca2",
  null
  
)

export default component.exports